import PropTypes from "prop-types";
import {useSearchParams, Link} from "react-router-dom";
import {toQueryString} from "lib/ext/object";
import usePagination from "lib/hooks/use-pagination";

function Button({disabled = false, icon, to}) {
  const [searchParams] = useSearchParams();

  if(disabled) {
    return (
      <button className="btn btn-gray btn-disabled" type="button">
        <i className={`fas ${icon}`} />
      </button>
    );
  }

  const queryString = toQueryString({
    ...Object.fromEntries(searchParams),
    page: to
  });

  return (
    <Link className="btn btn-gray" to={`?${queryString}`}>
      <i className={`fas ${icon}`} />
    </Link>
  );
}

Button.propTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  to: PropTypes.number.isRequired
};

export default function Navigation() {
  const {number, pages} = usePagination();

  return (
    <div className="btn-group">
      <Button disabled={number <= 1} icon="fa-angle-double-left" to={1} />
      <Button disabled={number <= 1} icon="fa-angle-left" to={number - 1} />
      <button className="btn btn-gray btn-disabled" type="button">{number}</button>
      <Button disabled={number >= pages} icon="fa-angle-right" to={number + 1} />
      <Button disabled={number >= pages} icon="fa-angle-double-right" to={pages} />
    </div>
  );
}
